// ===========================================================================
// "Translate to": the language this person reads messages in, in a chat header.
//
// The site guesses a language from the browser and the person changes it here:
// a Russian-set phone in Ukrainian hands, an English writer whose browser says
// French (both seen on the site, 2026-09-15). The list is what the operator
// has switched on, handed over from WELCOME; "Don't translate" is always the
// last choice. Built hidden and empty, shown once the list arrives, so a site
// with translation off never shows a control.
//
// The words "Translate to" sit in front of the menu. A bare "English" in the
// header said nothing about what it was for; the operator looked straight
// past it (2026-09-15). ASCII only.
// ===========================================================================

import { t } from '../i18n.js';
import { el } from '../dom.js';
import { languageName } from '@lumi/shared';

/**
 * @param {(code: string|null) => void} onPick a language code, or null for "don't translate"
 */
export function createLanguagePicker(onPick) {
  const select = el('select', { class: 'lang-pick-select', aria: { label: 'Translate messages into' } });
  select.addEventListener('change', () => onPick?.(select.value || null));
  // A label, so a tap on the words opens the menu too.
  const root = el('label', { class: 'lang-pick hidden', title: t('Translate messages into') }, [
    el('span', { class: 'lang-pick-label', text: t('Translate to') }),
    select,
  ]);
  return {
    root,
    select,
    /**
     * @param {string[]} codes the languages messages can be read in; empty hides the control
     * @param {string|null} current the one chosen, or null for "don't translate"
     */
    set(codes, current) {
      const list = Array.isArray(codes) ? codes.filter((c) => typeof c === 'string' && c) : [];
      select.replaceChildren();
      if (!list.length) {
        root.classList.add('hidden');
        return;
      }
      for (const code of list) select.append(el('option', { value: code, text: languageName(code) }));
      select.append(el('option', { value: '', text: t("Don't translate") }));
      select.value = current && list.includes(current) ? current : '';
      root.classList.remove('hidden');
    },
  };
}

export default { createLanguagePicker };
